<template>
  <HeaderForm :left-span="24">
    <template v-slot:prepend>
      <el-form
        ref="form"
        :inline="true"
        :model="value"
      >
        <el-form-item
          v-if="layoutType===1"
          prop="agreementCode"
        >
          <CommonSelect
            v-model="value.agreementCode"
            :request="siteProjectAgreementListByProject"
            :props="{label:'agreementName',value:'agreementCode'}"
            :params="params"
            placeholder="请选择协议"
            :clearable="false"
            @getDataSucess="getDataSucess"
          />
        </el-form-item>
        <el-form-item prop="logType">
          <el-select
            v-model="value.logType"
            clearable
            placeholder="请选择操作类型"
          >
            <el-option
              label="添加企业"
              value="ADD_CORP"
            />
            <el-option
              label="添加项目"
              value="ADD_PROJECT"
            />
            <el-option
              label="修改项目"
              value="UPDATE_PROJECT"
            />
            <el-option
              label="添加项目参建单位"
              value="ADD_PROJECT_CORP"
            />
            <el-option
              label="修改项目参建单位"
              value="UPDATE_PROJECT_CORP"
            />
            <el-option
              label="上传班组信息"
              value="ADD_TEAM"
            />
            <el-option
              label="修改班组信息"
              value="UPDATE_TEAM"
            />
            <el-option
              label="上传劳务工人基本信息"
              value="ADD_WORKER"
            />
            <el-option
              label="修改劳务工人基本信息"
              value="UPDATE_WORKER"
            />
            <el-option
              label="上传项目劳务工人信息"
              value="ADD_PROJECT_WORKER"
            />
            <el-option
              label="修改项目劳务工人信息"
              value="UPDATE_PROJECT_WORKER"
            />
            <el-option
              label="项目人员进退场"
              value="WORKER_ENTRY_EXIT"
            />
            <el-option
              label="上传劳务工人考勤"
              value="ADD_WORKER_ATTENDANCE"
            />
            <el-option
              label="设备门禁上报"
              value="ADD_DEVICE"
            />
            <el-option
              label="合同上报"
              value="ADD_CONTRACT"
            />
            <el-option
              label="证书上报"
              value="ADD_CERTIFICATE"
            />
            <el-option
              label="上报扬尘降噪"
              value="ADD_YCJZ"
            />
            <el-option
              label="上报塔吊基础信息"
              value="ADD_CRANE_BASE"
            />
            <el-option
              label="上报塔吊实时记录"
              value="ADD_CRANE_REALTIME_LOG"
            />
            <el-option
              label="上报塔吊循环工作"
              value="ADD_CRANE_WORK_LOG"
            />
            <el-option
              label="上报塔吊报警数据"
              value="ADD_CRANE_ALARM_LOG"
            />

          </el-select>
        </el-form-item>
        <el-form-item prop="sourceName">
          <el-input
            v-model="value.sourceName"
            clearable
            placeholder="请输入数据名称"
          />
        </el-form-item>
        <el-form-item prop="getResultStatus">
          <el-select
            v-model="value.getResultStatus"
            clearable
            placeholder="请选择状态"
          >
            <el-option
              label="全部"
              :value="null"
            />
            <el-option
              label="未获取"
              value="0"
            />
            <el-option
              label="获取成功"
              value="1"
            />
            <el-option
              label="获取失败"
              value="2"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          class="date"
          prop="time"
        >
          <el-date-picker
            v-model="value.time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
          >查询</el-button>
          <el-button
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </template>
  </HeaderForm>
</template>

<script>
import { siteProjectAgreementListByProject } from '@/api/manage'
export default {
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    layoutType: {
      type: Number,
      default: 1
    },
    agreementCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      siteProjectAgreementListByProject,
      params: {
        projectId: this.$store.state.user.projectItem.projectId
      }
    }
  },
  methods: {
    onSearch() {
      this.value.pageNumber = 1
      this.$emit('onSearch')
    },
    addNewData() {
      this.$emit('addNewData')
    },
    batchDelete() {
      this.$emit('batchDelete')
    },
    reset() {
      this.$refs.form.resetFields()
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    getDataSucess(agreementCode) {
      this.$nextTick(() => {
        if (!this.agreementCode) {
          this.$set(this.value, 'agreementCode', agreementCode)
        }
        this.onSearch()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select{
  width: 150px;
}
</style>
